// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"70":"bc8d7d35","408":"976d580e","530":"dc54df24","539":"f3fbee05","590":"5b67dc2c","598":"0664417b","736":"5b122ae7","787":"29bcf461","896":"add37a1a"}[chunkId] + ".chunk.js";
};